import { render, staticRenderFns } from "./plateformCompanyList.vue?vue&type=template&id=606acce4"
import script from "./plateformCompanyList.vue?vue&type=script&lang=js"
export * from "./plateformCompanyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports